import { render } from "./SpinnerOverlay.vue?vue&type=template&id=66cb05e7&scoped=true"
import script from "./SpinnerOverlay.vue?vue&type=script&lang=js"
export * from "./SpinnerOverlay.vue?vue&type=script&lang=js"

import "./SpinnerOverlay.vue?vue&type=style&index=0&id=66cb05e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cb05e7"]])

export default __exports__